import React from 'react';

/**
 * Sidebar primitives — dark nav column (sidebar-bg in both modes) with a
 * monogram brand mark, sectioned items, and a pinned footer.
 * Compose with <Sidebar>, <Sidebar.Section>, <Sidebar.Item>, <Sidebar.Footer>.
 * `Item` renders a plain element by default; pass `as={NavLink}` (or any
 * component) to integrate with the router — active styling is applied via the
 * `active` prop or NavLink's own isActive callback.
 */
export default function Sidebar({ brand, subtitle, monogram = 'G', children, className = '' }) {
  return (
    <aside className={`ui-sidebar ${className}`.trim()}>
      <div className="ui-sidebar__brand">
        <div className="ui-sidebar__monogram">{monogram}</div>
        <div style={{ lineHeight: 1.15 }}>
          <div style={{ fontWeight: 700, fontSize: 14 }}>{brand}</div>
          {subtitle && <div style={{ fontSize: 11, opacity: 0.6 }}>{subtitle}</div>}
        </div>
      </div>
      {children}
    </aside>
  );
}

Sidebar.Section = function Section({ children }) {
  return <div className="ui-sidebar__section">{children}</div>;
};

Sidebar.Item = function Item({ as: Comp = 'a', active = false, className = '', children, ...rest }) {
  const cls = `ui-sidebar__item${active ? ' ui-sidebar__item--active' : ''} ${className}`.trim();
  return <Comp className={cls} {...rest}>{children}</Comp>;
};

Sidebar.Footer = function Footer({ children }) {
  return <div className="ui-sidebar__footer">{children}</div>;
};
